export default __webpack_public_path__ + "static/media/Asscher_product.9d8f158b.png";